import React, { useEffect } from "react"
import MetaData from "../components/MetaData"
// import ml5 from "ml5"
import "bootstrap/dist/css/bootstrap.min.css"
import "../components/styles.css"
// import p5 from "p5"

// import loadable from "@loadable/component"

// const p5 = loadable(() => import("p5"))

// const ml5 = loadable(() => import("ml5"))
// const YourFunctionToUseMl5 = loadable(() => {
//   import ml5 from "ml5"
// })
// const YourFunctionToUseP5 = loadable(() => {
//   import p5 from "p5"
// })

import { loadableP5 as P5Wrapper } from "../components/loadable"
import Sketch from "../components/Sketch"
import { render } from "react-dom"
import Header from "../components/Header"
import { Container } from "react-bootstrap"
import Footer from "../components/Footer"
export default function Experiments() {
  // useEffect(() => {
  // const gotResult = (err, result) => {
  //   if (err) {
  //     console.error(err)
  //   } else {
  //     label = result[0].label.toUpperCase()
  //     probability = (result[0].confidence * 100).toFixed(2)
  //     classifier.classify(gotResult)
  //   }
  // }
  // const modelOnLoaded = () => {
  //   console.log("Model is Successfully Loaded!")
  // }
  // const videoReady = () => {
  //   classifier.classify(gotResult)
  // }
  // function sketch(p) {
  //   p.setup = () => {
  //     p.createCanvas(640, 480)
  //     video.hide()
  //     p.background(0)
  //   }
  //   p.draw = () => {
  //     p.background(0)
  //     p.image(video, 0, 0)
  //     p.fill(0)
  //     p.textSize(32)
  //     p.text(label, 10, p.height - 100)
  //     p.text(probability, 10, p.height - 30)
  //   }
  //   p.preload = () => {
  //     video = p.createCapture(p.VIDEO, videoReady)
  //     classifier = ml5.imageClassifier("MobileNet", video, modelOnLoaded)
  //   }
  // }
  // // new myP5(sketch, "sketch")
  // new p5(p => {
  //   p.setup = () => {
  //     p.createCanvas(640, 480)
  //     video.hide()
  //     p.background(0)
  //   }
  //   p.draw = () => {
  //     p.background(0)
  //     p.image(video, 0, 0)
  //     p.fill(0)
  //     p.textSize(32)
  //     p.text(label, 10, p.height - 100)
  //     p.text(probability, 10, p.height - 30)
  //   }
  //   p.preload = () => {
  //     video = p.createCapture(p.VIDEO, videoReady)
  //     classifier = ml5.imageClassifier("MobileNet", video, modelOnLoaded)
  //   }
  // }, "sketch")

  // <p5

  // }, [])

  return (
    <div>
      <MetaData />
      <Container
        fluid
        style={{
          textAlign: "center",
        }}
      >
        <Header />

        <h1 className="display-1">Image Classifier</h1>

        {/* <div id="sketch"></div> */}

        <P5Wrapper sketch={Sketch} />

        <Footer />
      </Container>
    </div>
  )
}
